import { PaginatedResponse } from "../types/webhook";

// ===== Types =====

export interface IncentiveFundSummary {
    totals: {
        total_in: number;
        total_out: number;
        balance: number;
    };
    filtered: {
        total_in: number;
        total_out: number;
        balance: number;
    };
}

export interface IncentiveFundPayment {
    id: number;
    user_id: number;
    program_id: number;
    amount: number;
    created_at: string;
    user?: {
        id: number;
        name: string;
        surname: string;
    };
    program?: {
        id: number;
        name: string;
    };
}

export interface IncentiveFundPayout {
    id: number;
    amount: number;
    comment: string | null;
    created_at: string;
}

export interface IncentiveFundPaymentsResponse {
    data: IncentiveFundPayment[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from?: number;
    to?: number;
    aggregated_sum: number;
    total_balance: number;
}

export interface IncentiveFundPayoutsResponse {
    data: IncentiveFundPayout[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from?: number;
    to?: number;
    aggregated_sum: number;
    total_balance: number;
}

export interface IncentiveFundParams {
    page?: number;
    per_page?: number;
    user_id?: number | string;
    program_id?: number | string;
    date_from?: string;
    date_to?: string;
}

export interface CreateIncentiveFundPayoutRequest {
    amount: number;
    comment?: string;
}

// ===== Endpoints =====

export const incentiveFundEndpoints = {
    getIncentiveFundSummary: {
        query: (params: IncentiveFundParams) => ({
            url: "/admin/incentive-fund/summary",
            params,
        }),
    },
    getIncentiveFundPayments: {
        query: (params: IncentiveFundParams) => ({
            url: "/admin/incentive-fund/payments",
            params,
        }),
    },
    getIncentiveFundPayouts: {
        query: (params: Omit<IncentiveFundParams, 'user_id' | 'program_id'>) => ({
            url: "/admin/incentive-fund/payouts",
            params,
        }),
    },
    createIncentiveFundPayout: {
        query: (body: CreateIncentiveFundPayoutRequest) => ({
            url: "/admin/incentive-fund/payouts",
            method: "POST",
            body,
        }),
    },
};

export const incentiveFundTags = ["IncentiveFund", "IncentiveFundSummary"];
